"use client";

import { useParams } from "next/navigation";

export default function HtmlWrapper({ children }: { children: React.ReactNode }) {
	const params = useParams();
	const locale = (params.lang as string) || "en";
	
	return (
		<html lang={locale}>
			{children}
		</html>
	);
}